module.exports = __webpack_public_path__ + "static/media/18.d65344b2.svg";